import Slide from './slide.js'
import BurgerMenu from './BurgerMenu.js'



function init() {

  let slide = new Slide()
  slide.init();

  let burger = new BurgerMenu();
  burger.init();
}

window.onload = init;
